/* eslint-disable react/jsx-no-bind, consistent-return */

import React, {useState} from "react";
import ColorSwatch from "./ColorSwatch";
import PropTypes from "prop-types";

const ColorOptions = ({setHoveredSwatchId, setSelectedSwatchId, swatches, selectedSwatchId}) => {
  const [
    displayName,
    setDisplayName
  ] = useState("");

  const getDisplayname = (swatchId) => {
    const activeSwatch = swatches.find(swatch => swatch.swatch_id === swatchId);

    return activeSwatch ? activeSwatch.swatch_name : null;
  };

  const handleMouseEnter = (swatchId) => {
    setDisplayName(getDisplayname(swatchId));
    setHoveredSwatchId(swatchId);
  };

  const handleMouseLeave = () => {
    setDisplayName("");
    setHoveredSwatchId(null);
  };

  const renderColorOptions = () =>
    swatches.map(swatch =>
      <ColorSwatch
        colorName={swatch.color_name}
        displayName={swatch.swatch_name}
        key={`color-swatch-${swatch.swatch_id}`}
        metalColor={swatch.metal_name}
        mouseEnterHandler={handleMouseEnter}
        mouseLeaveHandler={handleMouseLeave}
        onClick={() => setSelectedSwatchId(swatch.swatch_id)}
        selected={swatch.swatch_id === selectedSwatchId}
        stoneName={swatch.stone_name}
        swatchId={swatch.swatch_id}
      />);

  return (
    <div
      className="selections-section flex-1"
      data-test="add-to-cart-from-grid-colors"
    >
      <div className="px-2 text-left">
        {`Colors (${swatches.length})`}
      </div>
      <div className="pt-2 flex-1">
        <div className="inner max-h-[100px]">
          {renderColorOptions()}
        </div>
        <div className="pt-2 h-6">
          {displayName || getDisplayname(selectedSwatchId)}
        </div>
      </div>
    </div>
  );
};

ColorOptions.defaultProps = {"selectedSwatchId": null};

ColorOptions.propTypes = {
  "selectedSwatchId": PropTypes.number,
  "setHoveredSwatchId": PropTypes.func.isRequired,
  "setSelectedSwatchId": PropTypes.func.isRequired,
  "swatches": PropTypes.array.isRequired
};

export default ColorOptions;
